// removed by extract-text-webpack-plugin
module.exports = {"panel":"Accordion__panel___2PN2Q","panelHeading":"Accordion__panelHeading___3MK5u","title":"Accordion__title___2BNPG","titleContainer":"Accordion__titleContainer___1VbUa","checkboxContainer":"Accordion__checkboxContainer___1ASVH","selected":"Accordion__selected___1qQ1p","panelBody":"Accordion__panelBody___yi7f0"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/candidate/professionalSkills/components/Accordion.scss
// module id = 1764
// module chunks = 0